import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { queryKeys, queryOptions } from '../react-query-config'
import { generateEntropy, generateKeypair, generateNoise } from '../security'
import type { GenerateAESKeyResponseDto, GenerateKeyRequestDto } from '../types'

// Generate entropy hook
export const useGenerateEntropy = (): UseQueryResult<{ data: string }, Error> => {
  return useQuery<{ data: string }>({
    queryKey: queryKeys.security.entropy(),
    queryFn: () => generateEntropy(),
    ...queryOptions.security,
    enabled: false,
  })
}

// Generate noise hook
export const useGenerateNoise = (): UseQueryResult<{ data: string }, Error> => {
  return useQuery<{ data: string }>({
    queryKey: queryKeys.security.noise(),
    queryFn: () => generateNoise(),
    ...queryOptions.security,
    enabled: false,
  })
}

// Generate keypair hook
export const useGenerateKeypair = (
  keyType: GenerateKeyRequestDto['keyType'],
): UseQueryResult<GenerateAESKeyResponseDto | { [key: string]: never }, Error> => {
  return useQuery<GenerateAESKeyResponseDto | { [key: string]: never }>({
    queryKey: queryKeys.security.keypair(),
    queryFn: () => generateKeypair({ keyType }),
    ...queryOptions.security,
    enabled: false,
  })
}
